<template>
    <div class="container admin-table-page">
        <!-- HEADER -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>

        <!-- FILTROS PRINCIPALES -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100 flex-wrap">
                <div class="filters-container d-flex align-items-center flex-wrap">
                    <b-form-select 
                        :value="selReporte" 
                        @change="f_actualiza_reporte($event)" 
                        class="filter-select"
                    >
                        <b-form-select-option value="">{{ labels.selectReporte }}</b-form-select-option>
                        <option v-for="r in listReportes" :key="r.id" :value="r.reporte">
                            {{ r.reporte }} - {{ r.descripcion }}
                        </option>
                    </b-form-select>

                    <b-button class="table-toolbar-add-btn ml-2" @click="openCreateGrupo" :disabled="!selReporte">
                        <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                        Crear Grupo
                    </b-button>

                    <b-button class="table-toolbar-add-btn ml-2" @click="openCreateCodigoMaestro" :disabled="!selReporte">
                        <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                        Crear Código
                    </b-button>

                    <!-- NUEVO BOTÓN PARA EDITAR CÓDIGO -->
                    <b-button class="table-toolbar-add-btn ml-2" style="background-color: #FF924C; border-color: #FF924C;" @click="openEditCodigoMaestro" :disabled="!selReporte">
                        <font-awesome-icon :icon="['fas', 'pencil-alt']" class="mr-1" />
                        Editar Código
                    </b-button>

                    <b-button class="consult-btn ml-2" @click="consultaCuentas" :disabled="!selReporte || isLoading">
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>

        <!-- TABLA PRINCIPAL -->
        <div class="admin-table-block mt-4">
            <div v-if="!showTabla && !isLoading">
                <CorporateDataTable
                    :items="[]" :fields="[]" :labels="tableLabels" :loading="false"
                    :default-per-page="10" :page-options="[10]" :narrow="false"
                    :table-min-height="400" :table-max-height="500"
                    :show-search="false" :allow-column-toggle="false"
                    :enable-sorting="false" :show-pagination="false" :show-rows-per-page="false"
                >
                    <template #empty-state>
                        <div class="text-center py-5">
                            <font-awesome-icon :icon="['fas', 'search']" size="3x" class="text-muted mb-3" style="opacity: 0.3;" />
                            <p class="h4 text-muted">{{ labels.selectFilters }}</p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>

            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>

            <div v-if="showTabla && !isLoading" class="table-wrapper">
                <CorporateDataTable
                    :items="filaTableData" :fields="filaFields" :labels="filaTableLabels"
                    :default-per-page="10" :page-options="[10, 20, 50, 100]" :narrow="false"
                    :table-min-height="400" :table-max-height="500"
                    :show-search="true" :allow-column-toggle="true" :enable-sorting="true"
                    :filter-defs="filaFilterDefs" :toolbar-disabled="false"
                    :show-pagination="true" :show-rows-per-page="true"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button size="sm" class="table-toolbar-add-btn" @click="openCreateFila">
                                <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                                {{ labels.createFila }}
                            </b-button>
                        </div>
                    </template>

                    <template #cell(cuentas)="data">
                        <div class="text-left cuentas-cell" :title="data.value">
                            {{ data.value || '—' }}
                        </div>
                    </template>

                    <template #cell(accionEdit)="slotProps">
                        <b-button style="background-color:#FF924C; width:30px; height:30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;"
                            @click.stop="editFila(slotProps.item)">
                            <font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs" />
                        </b-button>
                    </template>

                    <template #cell(accionDelete)="{ item }">
                        <b-button class="reset-btn-danger" style="width:30px; height:30px; padding:0; display:flex; align-items:center; justify-content:center; border-radius:4px; margin:0 auto;"
                            @click.stop="deleteFila(item)">
                            <font-awesome-icon :icon="['fas', 'trash']" size="xs" />
                        </b-button>
                    </template>

                    <template #empty>
                        <div class="text-center py-4">
                            <font-awesome-icon :icon="['fas', 'table']" class="empty-table-icon" />
                            <p class="text-muted mt-2">{{ labels.noRows }}</p>
                        </div>
                    </template>
                </CorporateDataTable>
            </div>
        </div>

        <!-- MODAL CREAR GRUPO -->
        <b-modal :model-value="showModGrupo" :no-close-on-backdrop="true" hide-footer centered size="md"
            title="Crear Nuevo Grupo"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="cerrarModalGrupo">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Crear Grupo</div>
                    <div class="password-policy-subtitle">Ingresa los datos del nuevo grupo para este reporte.</div>
                </div>
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Grupo</label></div>
                    <div class="col-md-8"><input v-model.number="grupoFormData.grupo" type="number" min="1" class="form-control form-control-sm form-input" /></div>
                </div>
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Descripción</label></div>
                    <div class="col-md-8"><input v-model="grupoFormData.descripcion" maxlength="200" class="form-control form-control-sm form-input" placeholder="Ingrese una descripción..." /></div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="cerrarModalGrupo">Cancelar</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardarGrupo" :disabled="!grupoFormData.grupo || !grupoFormData.descripcion || isLoading">Guardar</b-button>
                </div>
            </div>
        </b-modal>

        <!-- MODAL CREAR CÓDIGO MAESTRO -->
        <b-modal :model-value="showModCodigoMaestro" :no-close-on-backdrop="true" hide-footer centered size="md"
            title="Crear Nuevo Código"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="cerrarModalCodigoMaestro">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Crear Código</div>
                    <div class="password-policy-subtitle">Ingresa los datos del nuevo código para este reporte.</div>
                </div>
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Grupo</label></div>
                    <div class="col-md-8">
                        <b-form-select v-model.number="codigoMaestroFormData.grupo" class="form-control form-control-sm form-input">
                            <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                            <option v-for="g in listGrupos" :key="g.id" :value="g.grupo">{{ g.grupo }} - {{ g.descripcion }}</option>
                        </b-form-select>
                    </div>
                </div>
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Código</label></div>
                    <div class="col-md-8"><input v-model.number="codigoMaestroFormData.codigo" type="number" min="1" class="form-control form-control-sm form-input" /></div>
                </div>
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Descripción</label></div>
                    <div class="col-md-8"><input v-model="codigoMaestroFormData.descripcion" maxlength="200" class="form-control form-control-sm form-input" placeholder="Ingrese una descripción..." /></div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="cerrarModalCodigoMaestro">Cancelar</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardarCodigoMaestro" :disabled="!codigoMaestroFormData.grupo || !codigoMaestroFormData.codigo || !codigoMaestroFormData.descripcion || isLoading">Guardar</b-button>
                </div>
            </div>
        </b-modal>

        <!-- MODAL EDITAR CÓDIGO MAESTRO -->
        <b-modal :model-value="showModEditCodigoMaestro" :no-close-on-backdrop="true" hide-footer centered size="md"
            title="Editar Código"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            @hide="cerrarModalEditCodigoMaestro">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">Editar Código</div>
                    <div class="password-policy-subtitle">Selecciona un código para cambiar su grupo o descripción.</div>
                </div>
                
                <div class="uniform-form-row d-flex align-items-center mb-3">
                    <div class="col-md-4 uniform-label-col"><label class="field-label required">Código</label></div>
                    <div class="col-md-8">
                        <b-form-select v-model.number="editCodigoFormData.codigo" @change="onSelectCodigoToEdit" class="form-control form-control-sm form-input">
                            <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                            <option v-for="c in listCodigosMaestros" :key="c.id" :value="c.codigo">{{ c.codigo }} - {{ c.descripcion }}</option>
                        </b-form-select>
                    </div>
                </div>

                <template v-if="editCodigoFormData.codigo">
                    <div class="uniform-form-row d-flex align-items-center mb-3">
                        <div class="col-md-4 uniform-label-col"><label class="field-label required">Nuevo Grupo</label></div>
                        <div class="col-md-8">
                            <b-form-select v-model.number="editCodigoFormData.grupo" class="form-control form-control-sm form-input">
                                <b-form-select-option :value="null">Seleccione...</b-form-select-option>
                                <option v-for="g in listGrupos" :key="g.id" :value="g.grupo">{{ g.grupo }} - {{ g.descripcion }}</option>
                            </b-form-select>
                        </div>
                    </div>
                    <div class="uniform-form-row d-flex align-items-center mb-3">
                        <div class="col-md-4 uniform-label-col"><label class="field-label required">Descripción</label></div>
                        <div class="col-md-8"><input v-model="editCodigoFormData.descripcion" maxlength="200" class="form-control form-control-sm form-input" /></div>
                    </div>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="cerrarModalEditCodigoMaestro">Cancelar</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardarEditCodigoMaestro" :disabled="!editCodigoFormData.codigo || !editCodigoFormData.grupo || !editCodigoFormData.descripcion || isLoading">Guardar</b-button>
                </div>
            </div>
        </b-modal>

        <!-- MODAL CREAR/EDITAR FILA DE CUENTAS -->
        <b-modal :model-value="showModFila" :no-close-on-backdrop="true" hide-footer centered size="xl"
            dialog-class="modal-asocia-menu-wide"
            :title="isEditingFila ? labels.editFila : labels.createFila"
            header-class="reset-modal-header" title-class="reset-modal-title" body-class="reset-modal-body"
            class="reset-password-dialog modal-fixed-height"
            @hide="cerrarModalFila">
            
            <div class="uniform-modal-body uniform-modal-body--wide">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ isEditingFila ? labels.editFila : labels.createFila }}</div>
                    <div class="password-policy-subtitle">
                        {{ isEditingFila ? 'Modifica los datos de la agrupación de cuentas.' : 'Ingresa los datos de la nueva agrupación de cuentas.' }}
                    </div>
                </div>

                <div class="menu-association-layout fila-layout">
                    <div class="menu-content" style="width: 100%;">
                        <div class="menu-content-title">Detalles de la Agrupación</div>

                        <div class="fila-content-scroll">
                            <div class="fila-section">
                                <div class="fila-field fila-field--grow">
                                    <label class="field-label required">Código (Maestro)</label>
                                    <b-form-select v-model.number="filaFormData.codigo" class="form-input">
                                        <b-form-select-option :value="null">Seleccione un código...</b-form-select-option>
                                        <option v-for="c in listCodigosMaestros" :key="c.id" :value="c.codigo">
                                            {{ c.codigo }} - {{ c.descripcion }}
                                        </option>
                                    </b-form-select>
                                </div>
                            </div>

                            <div class="fila-section">
                                <div class="fila-field">
                                    <label class="field-label">CIIU</label>
                                    <b-form-select v-model="filaFormData.ciiu" class="form-input">
                                        <b-form-select-option value="">Sin CIIU</b-form-select-option>
                                        <option v-for="c in listCiius" :key="c.ciiu" :value="c.ciiu">{{ c.ciiu }} - {{ c.descripcion }}</option>
                                    </b-form-select>
                                </div>
                                <div class="fila-field">
                                    <label class="field-label">Alterno</label>
                                    <b-form-input v-model="filaFormData.alterno" type="number" class="form-input" placeholder="Ej. 104" />
                                </div>
                            </div>

                            <div class="fila-field mb-2 mt-3">
                                <label class="field-label">Seleccione las cuentas para esta agrupación</label>
                                <b-form-input v-model="critCuenta" class="form-input mb-2" placeholder="Buscar por cuenta o descripción..." @input="filtraCuentas" />
                                
                                <div class="custom-scroll-table" style="height: 200px; min-height: 200px; max-height: 200px;">
                                    <table class="table table-sm table-hover" style="font-size:13px; margin-bottom:0;">
                                        <thead>
                                            <tr>
                                                <th style="width:150px;">{{ labels.cuenta }}</th>
                                                <th>{{ labels.description }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="c in listCuentasFiltradas" :key="c.cuenta"
                                                @click="toggleCuentaSelection(c)"
                                                :class="{ 'table-active-blue': isCuentaSelected(c) }"
                                                style="cursor:pointer;">
                                                <td><strong>{{ c.cuenta }}</strong></td>
                                                <td :title="c.descripcion">{{ c.descripcion }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="mt-2 d-flex justify-content-between" style="font-size:13px; color:#6c757d;">
                                    <span>{{ labels.selected }}: <strong>{{ filaFormData.cuentasSeleccionadas.length }}</strong></span>
                                    <b-button size="sm" class="reset-btn-secondary" style="padding: 2px 10px; font-size: 12px;" @click="toggleSelectAllCuentas">
                                        {{ selectAllCuentas ? 'Deseleccionar todas' : 'Seleccionar todas las visibles' }}
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="cerrarModalFila">{{ labels.cancel }}</b-button>
                    <b-button class="reset-btn-primary" @click="guardarFila" :disabled="!isFilaValid || isLoading">{{ labels.save }}</b-button>
                </div>
            </div>
        </b-modal>

        <!-- MODAL CONFIRMACIÓN ELIMINAR -->
        <b-modal :model-value="showConfirmDeleteModal" :no-close-on-backdrop="true" hide-footer centered size="md"
            :title="labels.confirmDelete" header-class="reset-modal-header" title-class="reset-modal-title"
            body-class="reset-modal-body" @hide="closeConfirmDeleteModal">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.areYouSure }}</div>
                    <div class="password-policy-subtitle">{{ labels.confirmDeleteText }}</div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmDeleteModal">{{ labels.cancel }}</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeDelete" style="background-color:#cd2838; border-color:#cd2838;">{{ labels.confirm }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ReporteResumenService from '../../services/ReporteResumen'
import CorporateDataTable from '../utils/CorporateDataTable.vue'

export default {
    name: 'ReporteResumen',
    components: { CorporateDataTable },

    data: () => ({
        listReportes: [],
        listGrupos: [],
        listCodigosMaestros: [],
        listFilas: [],
        listCuentasDisponibles: [],
        listCuentasFiltradas: [],
        listCiius: [],

        selReporte: '',
        critCuenta: '',

        isLoading: false,
        showTabla: false,

        // Modal Grupo
        showModGrupo: false,
        grupoFormData: { grupo: null, descripcion: '' },

        // Modal Crear Código
        showModCodigoMaestro: false,
        codigoMaestroFormData: { grupo: null, codigo: null, descripcion: '' },

        // Modal Editar Código
        showModEditCodigoMaestro: false,
        editCodigoFormData: { id: null, codigo: null, grupo: null, descripcion: '' },

        // Modal Fila
        showModFila: false,
        isEditingFila: false,
        touchedFila: false,
        selectAllCuentas: false,
        filaFormData: { id_cuenta: null, codigo: null, ciiu: '', alterno: '', cuentasSeleccionadas: [] },

        // Delete
        showConfirmDeleteModal: false,
        deleteId: null,
        deleteIdCodigo: null,
        deleteTarget: '',
        isDeleteAll: false
    }),

    computed: {
        labels() {
            const es = this.$store.state._language == "es-ES"
            return {
                title: es ? 'Reporte Resumen' : 'Summary Report',
                selectReporte: es ? 'Seleccione Reporte' : 'Select Report',
                consultar: es ? 'Consultar' : 'Consult',
                selectFilters: es ? 'Seleccione un reporte para consultar' : 'Select a report to consult',
                loading: es ? 'Cargando...' : 'Loading...',
                createFila: es ? 'Crear Agrupación' : 'Create Grouping',
                editFila: es ? 'Editar Agrupación' : 'Edit Grouping',
                edit: es ? 'Editar' : 'Edit',
                delete: es ? 'Eliminar' : 'Delete',
                codigo: es ? 'Código' : 'Code',
                descripcionCodigo: es ? 'Descripción Código' : 'Code Description',
                descripcion: es ? 'Descripción' : 'Description',
                description: es ? 'Descripción' : 'Description',
                cuentas: es ? 'Cuentas' : 'Accounts',
                cuenta: es ? 'Cuenta' : 'Account',
                ciiu: es ? 'CIIU' : 'CIIU',
                alterno: es ? 'Alterno' : 'Alternate',
                noRows: es ? 'No hay registros disponibles' : 'No records available',
                confirmDelete: es ? 'Confirmar Eliminación' : 'Confirm Delete',
                areYouSure: es ? '¿Está seguro?' : 'Are you sure?',
                confirmDeleteText: es ? '¿Está seguro que desea eliminar este registro?' : 'Are you sure you want to delete this record?',
                cancel: es ? 'Cancelar' : 'Cancel',
                confirm: es ? 'Confirmar' : 'Confirm',
                save: es ? 'Guardar' : 'Save',
                requiredField: es ? 'Este campo es requerido' : 'This field is required',
                noMatches: es ? 'No se encontraron resultados' : 'No results found',
                searchPlaceholder: es ? 'Buscar en la tabla...' : 'Search in table...',
                rowsPerPage: es ? 'Filas por página:' : 'Rows per page:',
                noSort: es ? 'Sin orden' : 'No sorting',
                sortAsc: es ? 'A-Z / Menor a mayor' : 'A-Z / Low to high',
                sortDesc: es ? 'Z-A / Mayor a menor' : 'Z-A / High to low',
                columns: es ? 'Columnas' : 'Columns',
                showAllColumns: es ? 'Mostrar todas' : 'Show all',
                filters: es ? 'Filtros' : 'Filters',
                clearFilters: es ? 'Limpiar filtros' : 'Clear filters',
                selected: es ? 'Seleccionadas' : 'Selected',
                grupo: es ? 'Grupo' : 'Group',
            }
        },

        filaTableData() {
            return (this.listFilas || []).map(item => ({
                id: item.id, 
                id_cuenta: item.id_cuenta, 
                grupo: item.grupo ? `${item.nombre_grupo || ''}` : '—', 
                codigo: item.codigo,
                desc_codigo: item.desc_codigo,
                ciiu: item.ciiu || '—',
                alterno: item.alterno || '—',
                cuentas: item.cuenta || '—'
            }))
        },

        filaFields() {
            return [
                { key: 'grupo', label: this.labels.grupo, sortable: true, thClass: 'text-center', tdClass: 'text-left align-middle', style: 'width: 200px;' }, 
                { key: 'codigo', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', style: 'width: 90px;' },
                { key: 'desc_codigo', label: this.labels.descripcionCodigo, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'ciiu', label: this.labels.ciiu, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', style: 'width: 80px;' },
                { key: 'alterno', label: this.labels.alterno, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', style: 'width: 80px;' },
                { key: 'cuentas', label: this.labels.cuentas, sortable: false, thClass: 'text-left', tdClass: 'text-left align-middle' },
                { key: 'accionEdit', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false, style: 'width: 70px;' },
                { key: 'accionDelete', label: this.labels.delete, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false, style: 'width: 70px;' }
            ]
        },

        filaFilterDefs() {
            return [
                { key: 'grupo', type: 'text', placeholder: 'Filtrar grupo...' },
                { key: 'codigo', type: 'text', placeholder: 'Filtrar código...' },
                { key: 'desc_codigo', type: 'text', placeholder: 'Filtrar descripción...' },
                { key: 'cuentas', type: 'text', placeholder: 'Filtrar cuentas...' }
            ]
        },

        tableLabels() {
            return {
                noRow: this.labels.noRows,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },

        filaTableLabels() {
            return { ...this.tableLabels, noRow: this.labels.noRows }
        },

        isFilaValid() {
            if (!this.filaFormData.codigo) return false
            if (this.filaFormData.cuentasSeleccionadas.length === 0) return false
            return true
        }
    },

    methods: {
        goBack() { this.$router.back() },

        cargarReportes() {
            this.isLoading = true
            ReporteResumenService.getAllReportes()
                .then(res => { this.listReportes = res.data.reportes || [] })
                .catch(err => { console.error(err); this.$toast.error('Error al cargar reportes') })
                .finally(() => { this.isLoading = false })
        },

        f_actualiza_reporte(valorSeleccionado) {
            this.selReporte = valorSeleccionado;
            this.listFilas = [];
            this.showTabla = false;

            if (this.selReporte) {
                this.cargarGrupos();
                this.cargarCodigosMaestros();
            }
        },

        cargarGrupos() {
            ReporteResumenService.getGruposByReporte(this.selReporte)
                .then(res => { this.listGrupos = res.data.grupos || [] })
                .catch(err => console.error(err))
        },

        cargarCodigosMaestros() {
            ReporteResumenService.getCodigosByReporte(this.selReporte)
                .then(res => { this.listCodigosMaestros = res.data.codigos || [] })
                .catch(err => console.error(err))
        },

        consultaCuentas() {
            if (!this.selReporte) { this.$toast.error('Seleccione un reporte'); return }
            this.isLoading = true
            this.listFilas = [];
            ReporteResumenService.getCodigosByGrupo(this.selReporte, null)
                .then(res => {
                    this.listFilas = (res.data.filas || []).filter(f => f.id_cuenta !== null);
                    this.showTabla = true
                })
                .catch(err => { console.error(err); this.$toast.error('Error al cargar datos') })
                .finally(() => { this.isLoading = false })
        },

        // ==== GRUPO ====
        async guardarGrupo() {
            if (!this.grupoFormData.grupo || !this.grupoFormData.descripcion) { this.$toast.warning('Complete todos los campos'); return }
            
            // Validar que no exista localmente
            const existe = this.listGrupos.some(g => g.grupo === this.grupoFormData.grupo);
            if (existe) {
                this.$toast.error('Ya existe un grupo con este número. Por favor elija otro.');
                return;
            }

            const userId = this.$store.state.userId || localStorage.getItem('userId')
            this.isLoading = true
            try {
                const payload = { reporte: parseInt(this.selReporte), grupo: this.grupoFormData.grupo, descripcion: this.grupoFormData.descripcion, idUser: parseInt(userId) }
                await ReporteResumenService.createGrupo(payload)
                this.$toast.success('Grupo creado')
                this.cerrarModalGrupo()
                this.cargarGrupos()
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Error al guardar')
            } finally { this.isLoading = false }
        },

        // ==== CREAR CÓDIGO ====
        openCreateCodigoMaestro() {
            this.codigoMaestroFormData = { grupo: null, codigo: null, descripcion: '' }
            this.showModCodigoMaestro = true
        },
        cerrarModalCodigoMaestro() { this.showModCodigoMaestro = false },
        async guardarCodigoMaestro() {
            if (!this.codigoMaestroFormData.grupo || !this.codigoMaestroFormData.codigo || !this.codigoMaestroFormData.descripcion) { this.$toast.warning('Complete todos los campos'); return }
            
            const existe = this.listCodigosMaestros.some(c => c.codigo === this.codigoMaestroFormData.codigo);
            if (existe) {
                this.$toast.error('Ya existe un código con este número. Por favor elija otro.');
                return;
            }

            const userId = this.$store.state.userId || localStorage.getItem('userId')
            this.isLoading = true
            try {
                const payload = { reporte: parseInt(this.selReporte), grupo: this.codigoMaestroFormData.grupo, codigo: this.codigoMaestroFormData.codigo, descripcion: this.codigoMaestroFormData.descripcion, idUser: parseInt(userId) }
                await ReporteResumenService.createCodigo(payload)
                this.$toast.success('Código creado')
                this.cerrarModalCodigoMaestro()
                this.cargarCodigosMaestros()
                this.consultaCuentas() 
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Error al guardar')
            } finally { this.isLoading = false }
        },

        // ==== EDITAR CÓDIGO ====
        openEditCodigoMaestro() {
            this.editCodigoFormData = { id: null, codigo: null, grupo: null, descripcion: '' }
            this.showModEditCodigoMaestro = true
        },
        cerrarModalEditCodigoMaestro() {
            this.showModEditCodigoMaestro = false
        },
        onSelectCodigoToEdit(codigoSeleccionado) {
            const codeInfo = this.listCodigosMaestros.find(c => c.codigo === codigoSeleccionado)
            if (codeInfo) {
                this.editCodigoFormData.id = codeInfo.id
                this.editCodigoFormData.grupo = codeInfo.grupo
                this.editCodigoFormData.descripcion = codeInfo.descripcion
            }
        },
        async guardarEditCodigoMaestro() {
            if (!this.editCodigoFormData.id || !this.editCodigoFormData.grupo || !this.editCodigoFormData.descripcion) { this.$toast.warning('Complete todos los campos'); return }
            const userId = this.$store.state.userId || localStorage.getItem('userId')
            this.isLoading = true
            try {
                const payload = {
                    id: this.editCodigoFormData.id,
                    grupo: this.editCodigoFormData.grupo,
                    descripcion: this.editCodigoFormData.descripcion,
                    idUser: parseInt(userId)
                }
                await ReporteResumenService.updateCodigoMaestro(payload)
                this.$toast.success('Código maestro actualizado')
                this.cerrarModalEditCodigoMaestro()
                this.cargarCodigosMaestros()
                this.consultaCuentas() 
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Error al actualizar')
            } finally { this.isLoading = false }
        },

        // ==== FILA ====
        openCreateFila() {
            this.isEditingFila = false
            this.touchedFila = false
            this.filaFormData = { id_cuenta: null, codigo: null, ciiu: '', alterno: '', cuentasSeleccionadas: [] }
            this.critCuenta = ''
            this.selectAllCuentas = false
            this.cargarCuentasDisponibles()
            this.cargarCiius()
            this.cargarCodigosMaestros() 
            this.showModFila = true
        },
        editFila(item) {
            this.isEditingFila = true
            this.touchedFila = false
            this.filaFormData = { 
                id_cuenta: item.id_cuenta, 
                codigo: item.codigo, 
                ciiu: item.ciiu !== '—' ? item.ciiu : '',
                alterno: item.alterno !== '—' ? item.alterno : '',
                cuentasSeleccionadas: item.cuentas !== '—' ? item.cuentas.split(',').filter(c => c !== '') : []
            }
            this.critCuenta = ''
            this.selectAllCuentas = false
            this.cargarCuentasDisponibles()
            this.cargarCiius()
            this.cargarCodigosMaestros()
            this.showModFila = true
        },
        cargarCuentasDisponibles() {
            ReporteResumenService.getCuentasDisponibles()
                .then(res => {
                    this.listCuentasDisponibles = res.data.cuentas || []
                    this.listCuentasFiltradas = [...this.listCuentasDisponibles]
                })
                .catch(err => console.error(err))
        },
        cargarCiius() {
            ReporteResumenService.getCiius()
                .then(res => { this.listCiius = res.data.ciius || [] })
                .catch(err => console.error(err))
        },
        filtraCuentas() {
            if (!this.critCuenta) { this.listCuentasFiltradas = [...this.listCuentasDisponibles]; return }
            const f = this.critCuenta.toUpperCase()
            this.listCuentasFiltradas = this.listCuentasDisponibles.filter(c => 
                String(c.cuenta).toUpperCase().includes(f) || String(c.descripcion).toUpperCase().includes(f)
            )
        },
        isCuentaSelected(c) { return this.filaFormData.cuentasSeleccionadas.includes(c.cuenta) },
        toggleCuentaSelection(c) {
            const idx = this.filaFormData.cuentasSeleccionadas.indexOf(c.cuenta)
            if (idx > -1) this.filaFormData.cuentasSeleccionadas.splice(idx, 1)
            else this.filaFormData.cuentasSeleccionadas.push(c.cuenta)
        },
        toggleSelectAllCuentas() {
            this.selectAllCuentas = !this.selectAllCuentas
            if (this.selectAllCuentas) {
                const cuentasVisibles = this.listCuentasFiltradas.map(c => c.cuenta)
                cuentasVisibles.forEach(c => {
                    if (!this.filaFormData.cuentasSeleccionadas.includes(c)) this.filaFormData.cuentasSeleccionadas.push(c)
                })
            } else {
                const cuentasVisibles = this.listCuentasFiltradas.map(c => c.cuenta)
                this.filaFormData.cuentasSeleccionadas = this.filaFormData.cuentasSeleccionadas.filter(c => !cuentasVisibles.includes(c))
            }
        },
        async guardarFila() {
            if (!this.isFilaValid) { this.touchedFila = true; this.$toast.warning('Complete los datos y seleccione al menos una cuenta'); return }
            const userId = this.$store.state.userId || localStorage.getItem('userId')
            this.isLoading = true
            try {
                const cuentasString = this.filaFormData.cuentasSeleccionadas.join(',')
                if (this.isEditingFila) {
                    const payload = { id: this.filaFormData.id_cuenta, codigo: this.filaFormData.codigo, ciiu: this.filaFormData.ciiu, alterno: this.filaFormData.alterno, cuenta: cuentasString, idUser: parseInt(userId) }
                    await ReporteResumenService.updateCuentaFila(payload)
                } else {
                    const payload = { reporte: parseInt(this.selReporte), codigo: this.filaFormData.codigo, ciiu: this.filaFormData.ciiu, alterno: this.filaFormData.alterno, cuenta: cuentasString, idUser: parseInt(userId) }
                    await ReporteResumenService.createCuentaFila(payload)
                }
                this.$toast.success(this.isEditingFila ? 'Agrupación actualizada' : 'Agrupación creada')
                this.cerrarModalFila()
                this.consultaCuentas()
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Error al guardar')
            } finally { this.isLoading = false }
        },
        cerrarModalFila() {
            this.showModFila = false
            this.filaFormData = { id_cuenta: null, codigo: null, ciiu: '', alterno: '', cuentasSeleccionadas: [] }
            this.touchedFila = false
            this.critCuenta = ''
            this.listCuentasFiltradas = []
            this.selectAllCuentas = false
        },
        deleteFila(item) {
            this.deleteId = item.id_cuenta;
            this.deleteIdCodigo = item.id; 
            this.deleteTarget = 'fila_cuentas'
            this.isDeleteAll = false
            this.showConfirmDeleteModal = true
        },
        closeConfirmDeleteModal() {
            this.showConfirmDeleteModal = false
            this.deleteId = null
            this.deleteIdCodigo = null
            this.deleteTarget = ''
            this.isDeleteAll = false
        },
        executeDelete() {
            if (this.deleteTarget === 'fila_cuentas') {
                ReporteResumenService.deleteCuentaFila(this.deleteId, this.deleteIdCodigo)
                    .then(() => { 
                        this.$toast.success('Registro eliminado'); 
                        this.closeConfirmDeleteModal(); 
                        this.consultaCuentas(); 
                    })
                    .catch(err => { this.$toast.error(err.response?.data?.message || 'Error al eliminar'); })
            }
        },
    },
    mounted() { this.cargarReportes() }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* Mismos estilos que ya tenías */
.niif-header .filters-container { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.niif-header .filter-select { min-width: 200px; max-width: 280px; width: auto; height: 38px; font-size: 14px; border-radius: 7px; }
.niif-header .consult-btn { height: 38px; min-height: 38px; padding: 0 20px; display: inline-flex; align-items: center; justify-content: center; white-space: nowrap; border-radius: 7px; font-size: 14px; background-color: #6c757d !important; color: white !important; border: 1px solid #6c757d !important; cursor: pointer; flex-shrink: 0; }
.niif-header .consult-btn:disabled { opacity: 0.65; cursor: not-allowed; }

.page-back-btn { padding: 0; font-size: 1.5rem; line-height: 1; }
.back-icon { font-size: 1.75rem !important; width: 1.75rem !important; height: 1.75rem !important; }
.param-title { font-size: 2rem !important; font-weight: 500; }

.niif-toolbar-right { display: flex; align-items: center; justify-content: flex-end; gap: 8px; flex: 0 0 auto; }
.table-toolbar-add-btn { height: 31px; min-height: 31px; padding: 0 14px; display: inline-flex; align-items: center; justify-content: center; white-space: nowrap; border-radius: 7px; font-size: 13px; background-color: #28a745; color: white; border: 1px solid #28a745; }
.table-toolbar-add-btn:hover:not(:disabled) { background-color: #218838; border-color: #1e7e34; }
.table-toolbar-add-btn:disabled { opacity: 0.65; cursor: not-allowed; }

.uniform-modal-body { padding: 8px 4px 4px 4px; }
.uniform-form-row { margin-bottom: 12px; }
.uniform-label-col label { margin-bottom: 0; font-weight: 500; font-size: 14px; }
.form-input { width: 100%; height: 38px; font-size: 14px; border-radius: 7px; }
.password-policy-box { background: white; border-radius: 8px; padding: 16px 20px; border-left: 4px solid #2e507a; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.password-policy-title { font-weight: 600; font-size: 15px; color: #2e507a; margin-bottom: 4px; }
.password-policy-subtitle { font-size: 13px; color: #6c757d; }
.uniform-actions-wrap { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; padding-top: 16px; border-top: 1px solid #e9ecef; flex-shrink: 0; }
.reset-btn-primary { background-color: #2e507a !important; border: 1px solid #2e507a !important; color: white !important; padding: 8px 24px; border-radius: 6px; font-weight: 500; transition: all 0.2s ease; }
.reset-btn-primary:hover:not(:disabled) { background-color: #1f3f62 !important; border-color: #1f3f62 !important; }
.reset-btn-primary:disabled { opacity: 0.65; cursor: not-allowed; }
.reset-btn-secondary { background-color: #f8f9fa !important; border: 1px solid #ced4da !important; color: #495057 !important; padding: 8px 24px; border-radius: 6px; font-weight: 500; transition: all 0.2s ease; }
.reset-btn-secondary:hover:not(:disabled) { background-color: #e9ecef !important; border-color: #adb5bd !important; color: #495057 !important; }
.reset-btn-secondary:focus, .reset-btn-secondary:active { box-shadow: none !important; outline: none !important; }
.reset-btn-secondary:disabled { opacity: 0.65; cursor: not-allowed; }
.reset-btn-danger { background-color: #cd2838 !important; border: 1px solid #cd2838 !important; color: white !important; border-radius: 6px; }
.reset-modal-header { background-color: #2e507a; color: white; padding: 16px 20px; border-radius: 8px 8px 0 0; }
.reset-modal-title { font-size: 18px; font-weight: 600; margin: 0; }
.reset-modal-body { padding: 24px 20px; background-color: #f8f9fa; overflow: hidden; }

.custom-scroll-table { height: 200px; min-height: 200px; max-height: 200px; overflow-y: auto; overflow-x: hidden; display: block; position: relative; border: 1px solid #dee2e6; border-radius: 8px; }
.custom-scroll-table table { display: table; width: 100%; table-layout: fixed; margin-bottom: 0; border-collapse: separate; border-spacing: 0; }
.custom-scroll-table table thead { display: table-header-group; position: sticky; top: 0; z-index: 10; }
.custom-scroll-table table thead th { background-color: #f8f9fa; border-bottom: 2px solid #dee2e6; padding: 6px 8px; font-weight: 600; font-size: 12px; color: #495057; position: sticky; top: 0; z-index: 10; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; }
.custom-scroll-table table thead th:first-child { width: 120px; }
.custom-scroll-table table tbody tr { cursor: pointer; }
.custom-scroll-table table tbody td { padding: 5px 8px; border: none; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; vertical-align: middle; }
.custom-scroll-table table tbody tr:hover td { background-color: #f5f9ff; }
.custom-scroll-table::-webkit-scrollbar { width: 8px; }
.custom-scroll-table::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.custom-scroll-table::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 4px; }
.table-active-blue { background-color: #e3f0ff !important; }
.table-active-blue td { background-color: #e3f0ff !important; }

.cuentas-cell { 
    font-family: inherit; 
    font-size: 13px; 
    word-break: break-word;
    white-space: normal;
    min-width: 200px;
}

.modal-fixed-height .modal-dialog { max-height: 90vh; }
.modal-fixed-height .modal-content { max-height: 90vh; overflow: hidden; position: relative; }
.modal-fixed-height .modal-body { overflow: hidden; padding: 24px 20px; }

.uniform-modal-body--wide { padding: 8px 4px 4px 4px; height: 100%; display: flex; flex-direction: column; }

.menu-association-layout { display: flex; gap: 20px; height: 380px; min-height: 380px; max-height: 380px; background: white; border-radius: 8px; overflow: hidden; border: 1px solid #e9ecef; flex-shrink: 0; }
.menu-content { flex: 1; padding: 16px 20px; overflow: hidden; display: flex; flex-direction: column; min-width: 0; }
.menu-content-title { font-size: 16px; font-weight: 600; color: #2e507a; padding-bottom: 12px; border-bottom: 2px solid #f0f2f5; margin-bottom: 12px; flex-shrink: 0; }

.fila-layout { height: 550px; min-height: 550px; max-height: 550px; }
.fila-content-scroll { flex: 1; overflow-y: auto; overflow-x: hidden; padding-right: 4px; }
.fila-content-scroll::-webkit-scrollbar { width: 6px; }
.fila-content-scroll::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }
.fila-content-scroll::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 3px; }

.fila-section { display: flex; gap: 16px; align-items: flex-start; flex-wrap: wrap; padding-bottom: 14px; margin-bottom: 14px; border-bottom: 1px solid #f0f2f5; }
.fila-field { display: flex; flex-direction: column; gap: 4px; min-width: 110px; }
.fila-field--grow { flex: 1; min-width: 200px; }
.fila-field .field-label { font-size: 13px; font-weight: 500; margin-bottom: 0; }

@media (max-width: 992px) {
    .niif-header .filters-container { flex-wrap: wrap; width: 100%; margin-top: 8px; gap: 6px; }
    .niif-header .filter-select { min-width: 150px; max-width: 200px; flex: 1 1 auto; }
}
@media (max-width: 768px) {
    .modal-fixed-height .modal-body { padding: 16px 12px; }
    .fila-layout { flex-direction: column; height: 650px; min-height: 650px; max-height: 650px; gap: 0; }
    .menu-content { padding: 12px 16px; min-height: 200px; flex: 1; }
    .uniform-actions-wrap { flex-direction: column; margin-top: 12px; padding-top: 12px; }
    .uniform-actions-wrap .reset-btn-secondary { width: 100%; margin: 4px 0 !important; }
}
</style>